// extracted by mini-css-extract-plugin
export default {"outer":"FormsManage_outer__xeWIL","filter":"FormsManage_filter__VNXgP"};